import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { newPathIsDifferent } from '../../utils/general/new-path-is-different'

/**
 * If path from BE exists and it's different than the page the User is on, redirect them to BE's path
 * @param desired - path coming from BE
 */
export const useValidateRoute = (desired?: string) => {
  const navigate = useNavigate()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const isEditParamPresent = urlParams.get('edit') === 'true'
    if (!isEditParamPresent) {
      if (desired && newPathIsDifferent(location.pathname, desired)) {
        // User should be redirected to another page
        void navigate(desired)
      }
    }
  }, [navigate, desired])
}
